export const LOGIN_REQUESTS = "LOGIN_REQUESTS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_REQUESTS = "REGISTER_REQUESTS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

export const LOAD_USER_REQUESTS = "LOAD_USER_REQUESTS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

export const UPDATE_PROFILE_REQUESTS = "UPDATE_PROFILE_REQUESTS";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_RESET = "UPDATE_PROFILE_RESET";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const UPDATE_PASSWORD_REQUESTS = "UPDATE_PASSWORD_REQUESTS";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_RESET = "UPDATE_PASSWORD_RESET";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const ADMIN_USER_REQUESTS = "ADMIN_USER_REQUESTS";
export const ADMIN_USER_SUCCESS = "ADMIN_USER_SUCCESS";
export const ADMIN_USER_FAIL = "ADMIN_USER_FAIL";

export const ADMIN_UPDATE_USER_REQUESTS = "ADMIN_UPDATE_USER_REQUESTS";
export const ADMIN_UPDATE_USER_SUCCESS = "ADMIN_UPDATE_USER_SUCCESS";
export const ADMIN_UPDATE_USER_FAIL = "ADMIN_UPDATE_USER_FAIL";
export const ADMIN_UPDATE_USER_RESET = "ADMIN_UPDATE_USER_RESET";

export const ADMIN_DELETE_USER_REQUESTS = "ADMIN_DELETE_USER_REQUESTS";
export const ADMIN_DELETE_USER_SUCCESS = "ADMIN_DELETE_USER_SUCCESS";
export const ADMIN_DELETE_USER_FAIL = "ADMIN_DELETE_USER_FAIL";
export const ADMIN_DELETE_USER_RESET = "ADMIN_DELETE_USER_RESET";

export const SINGLE_USER_REQUESTS = "SINGLE_USER_REQUESTS";
export const SINGLE_USER_SUCCESS = "SINGLE_USER_SUCCESS";
export const SINGLE_USER_FAIL = "SINGLE_USER_FAIL";
export const SINGLE_USER_RESET = "SINGLE_USER_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS";